import { Repository } from "./adapters/repository";
import { IconExtractor } from "./adapters/iconExtractor";

import * as addProjectExternalLink from "./useCases/addProjectExternalLink";
import * as editProjectExternalLink from "./useCases/editProjectExternalLink";
import * as removeProjectExternalLink from "./useCases/removeProjectExternalLink";
import * as retrieveProjectExternalLinks from "./useCases/retrieveProjectExternalLinks";

enum UseCases {
  addProjectExternalLink = "addProjectExternalLink",
  editProjectExternalLink = "editProjectExternalLink",
  removeProjectExternalLink = "removeProjectExternalLink",
  retrieveProjectExternalLinks = "retrieveProjectExternalLinks",
}

interface Core {
  [UseCases.addProjectExternalLink]: addProjectExternalLink.Interactor;
  [UseCases.editProjectExternalLink]: editProjectExternalLink.Interactor;
  [UseCases.removeProjectExternalLink]: removeProjectExternalLink.Interactor;
  [UseCases.retrieveProjectExternalLinks]: retrieveProjectExternalLinks.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
  iconExtractor: IconExtractor;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveProjectExternalLinks]:
      retrieveProjectExternalLinks.createInteractor(
        dependencies.repository,
        dependencies.iconExtractor,
      ),
    [UseCases.addProjectExternalLink]: addProjectExternalLink.createInteractor(
      dependencies.repository,
      dependencies.iconExtractor,
    ),
    [UseCases.editProjectExternalLink]:
      editProjectExternalLink.createInteractor(
        dependencies.repository,
        dependencies.iconExtractor,
      ),
    [UseCases.removeProjectExternalLink]:
      removeProjectExternalLink.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
